import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Backdrop, Spinner } from "./_loading";
import { useSelector } from "react-redux";
var LoadingComponent = function (_a) {
    var _b = _a.loading, loading = _b === void 0 ? false : _b;
    //const { loadingCount } = useLoadingState();
    var isLoading = useSelector(function (state) { return state.ui.isLoading; });
    console.log("loading", isLoading);
    return (_jsx(_Fragment, { children: (isLoading) && (_jsx(Backdrop, { children: _jsx(Spinner, { role: "progressbar", children: _jsx("svg", { viewBox: "22 22 44 44", children: _jsx("circle", { cx: "44", cy: "44", r: "20.2", fill: "none", strokeWidth: "3.6" }) }) }) })) }));
};
export default LoadingComponent;
